import { createFileRoute } from "@tanstack/react-router";
import { CommandCatalogDetailPage } from "../../../components/system/CommandCatalogDetailPage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/command-catalog/$definitionId")({
  beforeLoad: requireSuperAdmin(),
  component: CommandCatalogDetailRoute,
});

function CommandCatalogDetailRoute() {
  const { definitionId } = Route.useParams();
  return <CommandCatalogDetailPage key={definitionId} definitionId={definitionId} />;
}
